import React from "react";
import Card from "../../components/Card";
import Table from "../../components/Table";
import EditClientModal from "./Components/EditClientModal";
import { documentStatusOptions, entityCategoryOptions, entityListColumns, useEntityList } from "./TableData";
import SearchBar from "../../components/SearchBar";
import DropDown from "../../components/DropDown";
import "./index.scss";

const ClientList = () => {
    const {
        currentPage,
        setCurrentPage,
        isEditModalOpen,
        selectedClient,
        isLoading,
        handleEdit,
        handleSaveClient,
        handleCloseModal,
        handleDelete,
        totalPages,
        currentEntities,
        itemsPerPage,
        pagination,
        searchQuery,
        setSearchQuery,
        entityCategory,
        setEntityCategory,
        documentStatus,
        setDocumentStatus
    } = useEntityList();



    return (
        <div className="client-list-page">
            <div className="page-header">
                <h1 className="page-title">All Clients/Vendor</h1>
            </div>


            <div className="filter-container-box">
                <SearchBar
                    value={searchQuery}
                    onChange={setSearchQuery}
                    placeholder="Search by entity name, email..."
                />
                <DropDown
                    name="entityCategory"
                    value={entityCategory}
                    onChange={(e) => setEntityCategory(e.target.value)}
                    options={entityCategoryOptions}
                />
                <DropDown
                    name="documentStatus"
                    value={documentStatus}
                    onChange={(e) => setDocumentStatus(e.target.value)}
                    options={documentStatusOptions}
                />
            </div>


            <Card>


                {isLoading ? (
                    <div className="loading-state">
                        <p>Loading entities...</p>
                    </div>
                ) : currentEntities.length === 0 ? (
                    <div className="empty-state">
                        <p>No entities found.</p>
                    </div>
                ) : (
                    <Table
                        columns={entityListColumns}
                        data={currentEntities}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        showPagination={true}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                        totalItems={pagination.totalItems}
                        itemsPerPage={itemsPerPage}
                        showPaginationInfo={true}
                    />
                )}
            </Card>

            <EditClientModal
                isOpen={isEditModalOpen}
                onClose={handleCloseModal}
                clientData={selectedClient}
                onSave={handleSaveClient}
            />
        </div>
    );
};

export default ClientList;